<template>
  <div>
    <Card class="p-5 mb-5" id="addgift-card" :disabled="loading">
      <!--begin::Body-->
      <div class="card-body row p-0 m-0">
        <!--begin::Action-->
        <div class="col-12 col-md-8 mt-5">
          <!--begin::Title-->
          <div class="text-white mb-7">
            <div class="fs-2x z-index-2 fw-bolder text-white mb-7">
              <div class="mb-3" v-html="$t('giftcode.newCodeInfo')"></div>
            </div>

            <Input
              placeholder="giftcode.giftcode"
              id="code"
              v-model="form.code"
              :state="validateState('code')"
              class="mb-0"
            />
          </div>
          <!--end::Title-->
          <!--begin::Action-->
          <div>
            <b-button variant="primary" class="rounded-sm" @click="save">
              {{ $t('giftcode.checkCode') }}
            </b-button>
          </div>
          <!--begin::Action-->
        </div>
        <!--begin::Illustration-->
        <div class="col-4 d-md-block d-none text-right m-0 p-0">
          <img
            src="/image/gift-card.png"
            class="illustration me-3 bottom-0 end-0 h-200px"
            alt=""
          />
        </div>
        <!--end::Illustration-->
      </div>
      <!--end::Body-->
    </Card>

    <b-skeleton-wrapper :loading="loading" v-if="checkCode">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <Card>
        <div class="card-body">
          <h3 class="mb-5">{{ $t('giftcode.discountProductInformation') }}</h3>
          <p class="mb-2">
            <b>{{ $t('giftcode.product') }} : </b>
            {{
              checkCode.productCatalog && checkCode.productCatalog.data
                ? checkCode.productCatalog.data.name
                : '-'
            }}
          </p>
          <p class="mb-2">
            <b>{{ $t('global.description') }} : </b>
            {{
              checkCode.productCatalog && checkCode.productCatalog.data
                ? checkCode.productCatalog.data.description
                : '-'
            }}
          </p>
          <p class="mb-2">
            <b>{{ $t('giftcode.discount') }} : </b>
            {{
              checkCode.gift_value +
              ' ' +
              (checkCode.gift_mode == 'percentage' ? '%' : checkCode.gift_mode)
            }}
          </p>
          <p class="mb-2">
            <b>{{ $t('giftcode.isUsed') }} : </b>
            {{ checkCode.is_used ? $t('global.true') : $t('global.false') }}
          </p>

          <p class="mb-2" v-if="!checkCode.is_used">
            <b-button
              variant="primary"
              class="rounded-sm"
              @click="redirectCode"
            >
              {{ $t('giftcode.useCode') }}
            </b-button>
          </p>
        </div>
      </Card>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AddGiftCode',
  mixins: [validationMixin],
  data() {
    return {
      form: {
        code: '',
      },
      loading: false,
      checkCode: '',
    }
  },
  validations: {
    form: {
      code: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    save() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.loading = true
      ApiService.get(
        `/core/gift-codes/code-exists?code=${this.form.code}&include=productCatalog`
      )
        .then(({ data }) => {
          this.loading = false
          this.checkCode = data.data
          this.$emit('updatePage')
        })
        .catch((data) => {
          this.$generateToast(
            this,
            'danger',
            this.$t('giftcode.notFound'),
            true
          )
          this.loading = false
        })
    },
    redirectCode() {
      this.$router.push(`/services/stash?code=${this.form.code}`)
    },
  },
}
</script>

<style lang="scss" scoped>
#addgift-card {
  background: #1c325e;
  img.illustration {
    right: 0;
  }
}
</style>
